import styled from 'styled-components';

export const RECENT_ACTIVITY_SKELETON_HEIGHT = '208px';

export const RecentActivityList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	padding: 0.5rem;

	> .entry {
		display: flex;
		align-items: flex-start;
		gap: 0.75rem;
		min-width: 0;
	}

	.icon {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		color: ${({ theme }) => theme.v3.colors.dark[8]};
		background: ${({ theme }) => theme.v3.colors.gray[4]};
	}

	.labels {
		display: flex;
		flex-direction: column;
		min-width: 0;
	}

	> .empty {
		min-height: 130px;
		padding: 1.5rem 0.25rem;
		text-align: center;
	}

	.activity-bullet {
		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		margin-right: 0.25rem;
		border-radius: 50%;
		background-color: ${({ theme }) => theme.v3.colors.gray[4]};
	}
`;
